import { fromJS } from "immutable"

import {
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_WATCHER,
  GET_SEGMENTS_FAILED,
  GET_SURVEY_TYPES_WATCHER,
  GET_SURVEY_TYPES_SUCCESS,
  GET_SURVEY_TYPES_FAILED,
  GET_SCOPE_TYPES_WATCHER,
  GET_SCOPE_TYPES_SUCCESS,
  GET_SCOPE_TYPES_FAILED,
  CREATE_MEASUREMENT_WATCHER,
  CREATE_MEASUREMENT_SUCCESS,
  CREATE_MEASUREMENT_FAILED,
  GET_ORGANIZATION_SURVEYS_WATCHER,
  GET_ORGANIZATION_SURVEYS_SUCCESS,
  GET_ORGANIZATION_SURVEYS_FAILED,
  GET_SEGMENTS_SURVEYS_WATCHER,
  GET_SEGMENTS_SURVEYS_SUCCESS,
  GET_SEGMENTS_SURVEYS_FAILED,
} from "./constants"

export const initialState = fromJS({
  segments: [],
  isLoadingSegments: true,
  surveyTypes: [],
  isLoadingSurveyTypes: true,
  scopeTypes: [],
  isLoadingScopeTypes: true,
  isLoadingCreateMeasurement: false,
  organizationSurveys: [],
  isLoadingOrganizationSurveys: false,
  segmentsSurveys: [],
  isLoadingSegmentsSurveys: false,
})

function measurementNewReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SEGMENTS_WATCHER:
      return state.set("isLoadingSegments", true).set("segments", [])
    case GET_SEGMENTS_SUCCESS:
      return state
        .set("isLoadingSegments", false)
        .set("segments", action.payload)
    case GET_SEGMENTS_FAILED:
      return state.set("isLoadingSegments", false).set("segments", [])
    case GET_SURVEY_TYPES_WATCHER:
      return state.set("isLoadingSurveyTypes", true).set("surveyTypes", [])
    case GET_SURVEY_TYPES_SUCCESS:
      return state
        .set("isLoadingSurveyTypes", false)
        .set("surveyTypes", action.payload)
    case GET_SURVEY_TYPES_FAILED:
      return state.set("isLoadingSurveyTypes", false).set("surveyTypes", [])
    case GET_SCOPE_TYPES_WATCHER:
      return state.set("isLoadingScopeTypes", true).set("scopeTypes", [])
    case GET_SCOPE_TYPES_SUCCESS:
      return state
        .set("isLoadingScopeTypes", false)
        .set("scopeTypes", action.payload)
    case GET_SCOPE_TYPES_FAILED:
      return state.set("isLoadingScopeTypes", false).set("scopeTypes", [])
    case CREATE_MEASUREMENT_WATCHER:
      return state.set("isLoadingCreateMeasurement", true)
    case CREATE_MEASUREMENT_SUCCESS:
      return state.set("isLoadingCreateMeasurement", false)
    case CREATE_MEASUREMENT_FAILED:
      return state.set("isLoadingCreateMeasurement", undefined)
    case GET_ORGANIZATION_SURVEYS_WATCHER:
      return state
        .set("isLoadingOrganizationSurveys", true)
        .set("organizationSurveys", [])
    case GET_ORGANIZATION_SURVEYS_SUCCESS:
      return state
        .set("isLoadingOrganizationSurveys", false)
        .set("organizationSurveys", action.payload)
    case GET_ORGANIZATION_SURVEYS_FAILED:
      return state
        .set("isLoadingOrganizationSurveys", false)
        .set("organizationSurveys", [])
    case GET_SEGMENTS_SURVEYS_WATCHER:
      return state
        .set("isLoadingSegmentsSurveys", true)
        .set("segmentsSurveys", [])
    case GET_SEGMENTS_SURVEYS_SUCCESS:
      return state
        .set("isLoadingSegmentsSurveys", false)
        .set("segmentsSurveys", action.payload)
    case GET_SEGMENTS_SURVEYS_FAILED:
      return state
        .set("isLoadingSegmentsSurveys", false)
        .set("segmentsSurveys", [])
    default:
      return state
  }
}

export default measurementNewReducer
